import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import { epoch, utc } from '../../util/datetime';
import type { ITicketProjectHistory } from './TicketProjectHistory.interface';

export default class TicketProjectHistory implements ITicketProjectHistory {
  id: string;
  idOwner: string;
  idStage: string;
  idStatus: number;
  timeStamp: number;

  static build = (data: ITicketProjectHistory) => new TicketProjectHistory(data);
  static blank = () => new TicketProjectHistory({ id: uuid(), timeStamp: epoch(utc()) });

  /**
   * Constructor
   * @param {ITicketProjectHistory} data
   */
  constructor(data?: ITicketProjectHistory) {
    this.id = toUUID(data?.id) || uuid();
    this.idOwner = toUUID(data?.idOwner);
    this.idStage = toUUID(data?.idStage);
    this.idStatus = parseInt(data?.idStatus || 0, 10);
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
